import services from './Services.module.css';
import { Link } from 'react-router-dom';

function Services() {
    return (
        <div id={services.main}>
            <div>
                <h2>Services</h2>                
                <p>These are the services provided by Phoenix Object Conservation, tailored to Fans &amp; Feathers</p>
                <div>
                    <figure>
                        <img id={services.titleimage} src="/img/Feather_2_crop-768x384.jpg" alt="Fans &amp; Feathers"></img>
                    </figure>
                </div>                
            </div>
            <div>
                <h3>Condition Assessment</h3>
                <p>This includes the examination of all materials on one or more objects to determine their stability and what deterioration processes are present.  It concludes with a treatment proposal tailored to address any structural defects and any desired visual improvements, such as cleaning.</p>
            </div>
            <div>
                <h3>Conservation Treatment</h3>                
                <p>This can include minor visual improvements such as cleaning and reshaping, to more interventive methods such as stabilisation treatments to prevent further damage or loss.  If desired, replacement and reconstruction of missing parts can be carried out where possible.  This is undertaken by respecting the historical and cultural context of the object.  As an accredited conservator, I follow the <Link to="https://www.icon.org.uk/resources/standards-and-ethics/icon-ethical-guidance.html">ICON Code of Ethics</Link>, and carry out all work to the highest standard.</p>
            </div>
            <div>
                <h3>Advice on Preventive Measures</h3>                
                <p>This includes recommendations on environmental conditions (temperature, humidity, light levels), handling and packing, as well as advice on integrated pest management.</p>
            </div>
        </div>
    );
}

export default Services;